import type { MutableRefObject } from 'react';
import { useState, createContext } from 'react';

export interface IPaginationContext {
    addPage: (id: MutableRefObject<number>) => number;
    isLastPage: boolean;
    nextPage: () => void;
    page: number;
    prevPage: () => void;
}

export const PaginationContext = createContext<IPaginationContext>({
    addPage: () => 0,
    isLastPage: false,
    nextPage: () => {},
    prevPage: () => {},
    page: 0,
});

export const usePagination = () => {
    const [page, setPage] = useState(0);
    const [pageList, setPages] = useState<number[]>([]);
    const addPage = () => {
        const next = pageList.length;

        pageList.push(next);
        setPages(Array.from(pageList));

        return next;
    };
    const prevPage = () => setPage(Math.max(0, page - 1));
    const nextPage = () => setPage(Math.min(pageList.length - 1, page + 1));
    const isLastPage = pageList.length === 0 || page === pageList.length - 1;

    return { isLastPage, page, addPage, prevPage, nextPage };
};
